export const BASE_URL = 'https://dev-api.farmgatetest.com.au/api/v1/';
export const SOCKET_URL = 'https://dev-api.farmgatetest.com.au/';
export const MODE = 'dev';
export const GOOGLE_API_KEY = 'AIzaSyAYogmFPs3EukCa091qNBC0DOtYN7Nr80Y';
export const APP_RELEASE = 'dev.1392044740';
